var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pipeline-chart',{attrs:{"title":'Potential Volume',"userRoute":_vm.userRoute,"type":'volume',"size":'4'}})}
var staticRenderFns = []

export { render, staticRenderFns }